import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSecureDataRequestSettings } from 'services/secureDataSharing';

export const ThunkGetSecureDataRequestSettings = createAsyncThunk(
  'secureDataSharing/getSecureDataRequestSettings',
  () => getSecureDataRequestSettings().then(r => r.data),
);
